import {queue} from "../../funcs";
import Backbone from "backbone";
import BaseApp from "../BaseApp";
import ContextMenuView from "../../classes/ContextMenuView";
import RowsStorage from "../../classes/storage/RowsStorage";
import langDictionary from "../../classes/lang/init";


const USER_TASK = RowsStorage.get("USER_TASK");

export default class TasksBgApp extends BaseApp {

    async preload(params, callback) {
        await this.getCounts();
        callback();
    }

    onReady() {
        this.initTray();

        this.initMenu();
        this.menuView.render();

        this.listenTaskChanges();
    }

    initTray() {
        this.trayBarChannel = system.apps.channel("TrayBar");

        this.trayItemModel = this.trayBarChannel.add({
            sort: 3,
            icon: "tasks",
            count: this.whiteCount,
            newCount: this.redCount
        });

        this.listenTo(this.trayItemModel, "click", this.onClickTrayItem.bind(this));
    }

    listenTaskChanges() {
        this.queue = queue();

        this.listenTo(USER_TASK.collection, "add change remove", () => {
            this.queue.debounce(() => {
                this.rematchCountsByCache();
                this.onChangeCounts();
            });
        });
    }

    onChangeCounts() {
        this.trayItemModel.set({
            count: this.whiteCount,
            newCount: this.redCount
        });
    }

    onClickTrayItem() {
        // this.showTasksTable();
        let $trayBarItemView = $(".TrayBarItemView-tasks");
        let trayBarWidth = $trayBarItemView.parent().width();
        let offset = $trayBarItemView.offset();
        this.menuView.moveTo(offset.left + trayBarWidth, offset.top);

        this.menuView.show();
    }

    async getCounts() {

        // Запрос кол-ва нельзя делать через customlogic
        // т.к. настроены права
        // (Админ видит все задачи, остальные только свои)
        //
        // потом пересчет кол-ва будет считаться из кэша
        // (чтобы не долбить сервер и не засорять пул)
        // поэтому нужно загрузить модели и хранить их
        await USER_TASK.get({
            columns: [
                "ID", "ID_USER_TASK_STATUS",
                // нужно для проверки прав, @see rematchCountsByCache
                "MANAGERS_IDS_AND_OWNER"
            ],
            filter: {
                status: {
                    type: "in",
                    key: "ID_USER_TASK_STATUS",
                    not: true,
                    value: [1, 4]
                }
            },
            // очень важная сортировка
            // нам нужно за один запрос достать
            // кол-во белых и кол-во красных
            // НО красные могут быть в конце таблицы
            // поэтому делаем сортировку по IS_RED
            sort: [{
                IS_RED: -1
            }],
            // по умолчанию, TableApi добавит сортировку по id
            // чтобы ускорить запрос, отрубаем это, чтобы сработал индекс на IS_RED
            sortById: false,

            // счетчик все равно не показывает число большее чем 99
            limit: 100
        });

        this.rematchCountsByCache();
    }

    isWhiteTask(taskModel) {
        let statusId = taskModel.get("ID_USER_TASK_STATUS");

        return (
            statusId != 1
                && statusId != 4
        );
    }

    isRedTask(taskModel) {
        return taskModel.get("ID_USER_TASK_STATUS") == 7;
    }

    rematchCountsByCache() {
        let redCount = 0;
        let whiteCount = 0;

        let rightsFilter = USER_TASK.getRightsAccessFilter();

        USER_TASK.collection.each((taskModel) => {
            if ( rightsFilter ) {
                if ( !rightsFilter.check(taskModel) ) {
                    return;
                }
            }

            if ( this.isWhiteTask(taskModel) ) {
                whiteCount++;
            }

            if ( this.isRedTask(taskModel) ) {
                redCount++;
            }
        });

        this.whiteCount = whiteCount;
        this.redCount = redCount;
    }

    initMenu() {
        this.menuView = new ContextMenuView({
            addClassName: "sub-main-menu",
            collection: new Backbone.Collection([
                {
                    name: langDictionary.getAppTitle("tasks_current"),
                    menuItem: "tasks_current"
                },
                {
                    name: langDictionary.getAppTitle("tasks_archive"),
                    menuItem: "tasks_archive"
                },
                {
                    name: langDictionary.getAppTitle("tasks_all"),
                    menuItem: "tasks_all"
                },
                {
                    name: langDictionary.getAppTitle("tasks_operation_unit"),
                    menuItem: "tasks_operation_unit"
                }
            ]),
            zIndex: 9999999999
        });

        this.listenTo(this.menuView, "itemClick", this.onClickMenu);
    }

    async onClickMenu(e, item) {
        const appName = item.get("menuItem");

        this.tasksApp = await system.run({ app: appName });

        if ( this.tasksApp ) {
            this.listenTo(this.tasksApp, "destroy", () => {
                this.tasksApp = null;
            });
        }

        this.menuView.hide();
    }
}
